import { isEmpty, chain } from 'underscore';
import React, { useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessages } from '@bingads-webui-react/validation';
import { ErrorsContext } from './error-context';
import { errorMessage, uniqueErrorTransform } from '../rules/errors';

const ErrorItem = React.memo(({ errors, errorFilter, children }) => {
  const focusElementRef = useRef();

  const filteredErrors = useMemo(
    () => chain(errors)
      .uniq(uniqueErrorTransform)
      .filter(errorFilter)
      .map(errorMessage)
      .value(),
    [errors, errorFilter]
  );

  useEffect(() => {
    if (errors && !errors.isHandled && !isEmpty(filteredErrors)) {
      // eslint-disable-next-line no-param-reassign
      errors.isHandled = true;
      focusElementRef.current.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, [filteredErrors, errors]);

  return (
    <React.Fragment>
      <div ref={focusElementRef} style={{ position: 'relative', display: 'block' }} />
      {children}
      <ErrorMessages messages={filteredErrors} />
    </React.Fragment>
  );
});

ErrorItem.propTypes = {
  children: PropTypes.node,
  errors: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ])),
  errorFilter: PropTypes.func.isRequired,
};

ErrorItem.defaultProps = {
  children: undefined,
  errors: [],
};

export const Errors = React.memo(({ filter: errorFilter, children }) => (
  <ErrorsContext.Consumer>
    {errors => (
      <ErrorItem errors={errors} errorFilter={errorFilter}>
        {children}
      </ErrorItem>
    )}
  </ErrorsContext.Consumer>
));

Errors.propTypes = {
  children: PropTypes.node,
  filter: PropTypes.func.isRequired,
};

Errors.defaultProps = {
  children: undefined,
  // filter: constant(true), // TODO: decide on the best default value
};
